<template>
	<div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
		<div class="w-full max-w-3xl lg:max-w-4xl">
			<div v-if="loading" class="text-center text-ihh-slate-gray py-16">Loading…</div>
			<div v-else class="static-page" v-safe-html="html"></div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { FINAL_SALE_CSS, FINAL_SALE_HTML } from '../../../../config/helpers/staticPages/finalSaleItemsSeed.js'

export default {
	name: 'FinalSaleItems',
	inject: ['store'],
	data() {
		return {
			html: FINAL_SALE_HTML,
			css: FINAL_SALE_CSS,
			loading: true,
			styleEl: null,
		}
	},
	async mounted() {
		await this.loadPublished()
		this.syncCss()
	},
	watch: {
		css() {
			this.syncCss()
		},
	},
	unmounted() {
		this.styleEl?.remove()
	},
	methods: {
		async loadPublished() {
			try {
				const { data } = await axios.get(`${this.store.api}/controllers/staticPages/published/final-sale-items`)
				if (data?.success && data.page?.html) {
					this.html = data.page.html
					this.css = data.page.css || FINAL_SALE_CSS
					if (data.page.metaTitle) document.title = data.page.metaTitle
				}
			} catch {
				// Keep the seeded fallback so a CMS outage does not blank /final-sale-items.
			} finally {
				this.loading = false
			}
		},
		syncCss() {
			if (!this.styleEl) {
				this.styleEl = document.createElement('style')
				this.styleEl.setAttribute('data-static-page', 'final-sale-items')
				document.head.appendChild(this.styleEl)
			}
			this.styleEl.textContent = this.css || FINAL_SALE_CSS
		},
	},
}
</script>
